/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
// Libraries
import React, { useCallback, useMemo } from 'react';

import { Button, space, Title, VStack } from '@meterup/atto';
import { formatDateTime, TimeFormat } from '@meterup/common';
import { put, QuoteRequest, QuoteRequestOnboarding, useApiResource } from '@meterup/connect-api';
import { QuoteRequestOnboarding_CompanyType } from '@meterup/connect-api/src/connectProtos';
import { c } from 'jotai-devtools/useAtomsDevtools-670c07b4';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { boolean } from 'zod';

// Components
import SidebarLayout from '../../components/Layout/SidebarLayout';
import QuotesContractSidebar from '../../components/QuotesContract/QuotesContractSidebar/QuotesContractSidebar';
import useQuotes from '../../hooks/useQuotes';
import { route } from '../../routes';

function isOnsiteContactSameAsSignor(quoteRequestOnboarding: QuoteRequestOnboarding): boolean {
  return quoteRequestOnboarding.signorContactEmail === quoteRequestOnboarding.onsiteContactEmail;
}

function formatCompanyType(businessType: QuoteRequestOnboarding_CompanyType): string {
  switch (businessType) {
    case QuoteRequestOnboarding_CompanyType.unknown:
      return '';
    case QuoteRequestOnboarding_CompanyType.llc:
      return 'LLC';
    case QuoteRequestOnboarding_CompanyType.corp:
      return 'Corp';
    case QuoteRequestOnboarding_CompanyType.partnership:
      return 'Partnership';
    default:
      return '';
  }
}

function QuoteRequestsCompleted() {
  const { sid } = useParams<{ sid: string }>();
  const [loadingQuoteRequest, quoteRequest, reloadQuoteRequest, failed] =
    useApiResource<QuoteRequest>(`quote-requests/${sid}`, false, true);
  const [loadingQuoteRequestOnboarding, quoteRequestOnboarding] =
    useApiResource<QuoteRequestOnboarding>(`quote-requests/${sid}/onboarding`, false, true);

  const selectedQuoteSids = useMemo(
    () => (quoteRequest ? quoteRequest.selectedQuotes : []),
    [quoteRequest],
  );
  const onsiteContactSameAsSignor = useMemo(
    () => !!quoteRequestOnboarding && isOnsiteContactSameAsSignor(quoteRequestOnboarding),
    [quoteRequestOnboarding],
  );

  // Quotes
  const { loadingQuotes, selectedQuotes } = useQuotes(
    // @ts-ignore
    sid,
    selectedQuoteSids,
  );

  const renderSidebar = () => {
    const hasDashboardAccess = document.cookie.includes('dashboard.frontend.v2');

    if (!quoteRequest) {
      return null;
    }
    return (
      <VStack spacing={space(6)}>
        <QuotesContractSidebar selectedQuotes={selectedQuotes} quoteRequest={quoteRequest} />
        {hasDashboardAccess && (
          <Button
            size="large"
            width="100%"
            variant="primary"
            as="a"
            className="mt-6"
            href="https://dashboard.meter.com/"
          >
            Return to dashboard
          </Button>
        )}
      </VStack>
    );
  };

  if (loadingQuoteRequest || loadingQuoteRequestOnboarding) {
    return null;
  }
  if (!quoteRequest || !quoteRequestOnboarding) {
    return null;
  }

  const addressLine1 = [
    quoteRequest?.location?.address?.address1,
    quoteRequest?.location?.address?.address2,
  ]
    .filter((e) => e)
    .join(', ');
  const addressLine2 = [
    quoteRequest?.location?.address?.city,
    quoteRequest?.location?.address?.state,
    quoteRequest?.location?.address?.postalCode,
  ]
    .filter((e) => e)
    .join(', ');

  return (
    <SidebarLayout sidebarChildren={renderSidebar()} hideSidebarOnMobile={false} align="top">
      <div className="mx-auto max-w-2xl max-w-screen-xs w-full">
        <Title>Thank you!</Title>
        <section className="border p-6 text-left rounded-lg justify-between bg-white border-gray-100 mt-6 flex flex-col md:flex-row">
          <div className="flex-1">
            <p className="text-gray-400 text-sm">
              {onsiteContactSameAsSignor ? 'Contact information' : 'Signor contact information'}
            </p>
            <div className="mt-2">
              Name:
              <span className="ml-1 text-gray-600">{quoteRequestOnboarding.signorContactName}</span>
            </div>
            <div className="mt-1">
              Email:
              <span className="ml-1 text-gray-600">
                {quoteRequestOnboarding.signorContactEmail}
              </span>
            </div>
            <div className="mt-1">
              Phone:
              <span className="ml-1 text-gray-600">
                {quoteRequestOnboarding.signorContactPhone}
              </span>
            </div>
            {!onsiteContactSameAsSignor && (
              <>
                <p className="mt-6 text-gray-400 text-sm">Onsite contact information</p>
                <div className="mt-2">
                  Name:
                  <span className="ml-1 text-gray-600">
                    {quoteRequestOnboarding.onsiteContactName}
                  </span>
                </div>
                <div className="mt-1">
                  Email:
                  <span className="ml-1 text-gray-600">
                    {quoteRequestOnboarding.onsiteContactEmail}
                  </span>
                </div>
                <div className="mt-1">
                  Phone:
                  <span className="ml-1 text-gray-600">
                    {quoteRequestOnboarding.onsiteContactPhone}
                  </span>
                </div>
              </>
            )}

            <p className="text-gray-400 text-sm mt-6">Business Details</p>
            <div className="mt-2">
              Legal name:
              <span className="ml-1 text-gray-600">{quoteRequestOnboarding.companyLegalName}</span>
            </div>
            <div className="mt-1">
              Tax ID:
              <span className="ml-1 text-gray-600">{quoteRequestOnboarding.companyTaxid}</span>
            </div>
            <div className="mt-1">
              State:
              <span className="ml-1 text-gray-600">{quoteRequestOnboarding.companyState}</span>
            </div>
            <div className="mt-1">
              Business type:
              <span className="ml-1 text-gray-600">
                {formatCompanyType(quoteRequestOnboarding.companyType)}
              </span>
            </div>
            <div className="mt-1">
              Incorporated date:
              <span className="ml-1 text-gray-600">
                {formatDateTime(
                  quoteRequestOnboarding.companyIncorporatedDate ?? '',
                  TimeFormat.SHORT,
                )}
              </span>
            </div>

            <p className="text-gray-400 text-sm mt-6">Install location</p>
            <div className="mt-2 text-gray-600">{addressLine1}</div>
            <div className="text-gray-600">{addressLine2}</div>
          </div>
          <div className="flex-1 flex flex-col mt-6 md:mt-0">
            <div className="flex-1">
              <p className="text-gray-400  text-sm">Next steps</p>
              <p className="mt-2 text-gray-600 mb-6">
                We’ll follow up shortly with any required paperwork (such as the SOA or contract)
                for signature. Once that’s completed, we’ll coordinate with you to schedule your
                installation.
              </p>
            </div>

            <div className="flex-1 flex md:items-end md:justify-end">
              <Link to={route('contact', { sid })}>
                <Button variant="secondary">Edit customer info</Button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </SidebarLayout>
  );
}

export default QuoteRequestsCompleted;
